import { render, staticRenderFns } from "./RelatedInspirations.vue?vue&type=template&id=0f6e5683"
import script from "./RelatedInspirations.vue?vue&type=script&lang=js"
export * from "./RelatedInspirations.vue?vue&type=script&lang=js"
import style0 from "./RelatedInspirations.vue?vue&type=style&index=0&id=0f6e5683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports